module.exports = __webpack_public_path__ + "static/media/hashple_actions.e29d2c8a.gif";